export default __webpack_public_path__ + "static/media/HeaderLogo.55e1318e.svg";